<template>
  <div>
    <v-data-table
      :items="items"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      :options.sync="options"
      :items-per-page="10"
      disable-sort
      :footer-props="{
        'items-per-page-options': [10, 20, 50],
        showFirstLastPage: true,
      }"
    >
      <template #[`item.subject`]="{ item }">
        {{ get(item, 'class.academicLevel.title') }}
      </template>

      <template #[`item.class`]="{ item }">
        <router-link :to="`/class/${get(item, 'class.id')}`" class="text-decoration-none">
          {{ get(item, 'class.title') }}
        </router-link>
      </template>

      <template #[`item.teachers`]="{ item }">
        <div v-for="(teacher, index) in get(item, 'class.teachers', [])" :key="teacher.id">
          <router-link :to="`/teacher/${teacher.id}`" class="text-decoration-none">
            {{ teacher.name }}
          </router-link>
          <template v-if="index < get(item, 'class.teachers', []).length - 1">, </template>
        </div>
      </template>

      <template #[`item.location`]="{ item }">
        {{ get(item, 'class.department.title') }}
      </template>

      <template #[`item.price`]="{ item }">
        <template v-if="get(item, 'class.metadata.classMode') === 'hybrid' && get(item, 'metadata.apply')">
          <div>Offline: {{ Number(item.amount).toLocaleString() }} VND {{ formatPriceType(item.priceType) }}</div>
          <div>Online: {{ Number(get(item, 'metadata.onlineAmount', 0)).toLocaleString() }} VND
            {{ formatPriceType(item.priceType) }}
          </div>
        </template>
        <template v-else-if="item.amount && get(item, 'metadata.apply')">
          {{ Number(item.amount).toLocaleString() }} VND
          {{ formatPriceType(item.priceType) }}
        </template>
      </template>

      <template #[`item.paymentType`]="{ item }">
        {{ formatPaymentType(item.paymentType) }}
      </template>

      <template #[`item.periodic`]="{ item }">
        {{ formatPeriodicType(get(item, 'metadata.periodic')) }}
      </template>

      <template #[`item.actualPaymentPeriod`]="{ item }">
        <v-icon
          v-if="get(item, 'metadata.apply')"
          @click="$refs['dialog-detail-period'].openDialog(item, get(item, 'class.metadata.classMode') === 'hybrid')"
        >
          mdi-eye
        </v-icon>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="editItem(item)">
              <v-list-item-title>Sửa</v-list-item-title>
            </v-list-item>
            <v-list-item @click="deleteItem(item)">
              <v-list-item-title>Xóa</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <DialogDetailPeriod ref="dialog-detail-period" />
    <DialogEditClassSetup ref="dialogEditClassSetup" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash-es'
import DialogDetailPeriod from './DialogDetailPeriod.vue'
import DialogEditClassSetup from '@/modules/tuitionFee/class-setup/DialogEditClassSetup.vue'
export default {
  name: 'TuitionFeeClassSetup',
  components: {
    DialogEditClassSetup,
    DialogDetailPeriod,
  },
  data() {
    return {
      get,
      options: {},
      headers: [
        { text: 'Bộ môn', value: 'subject' },
        { text: 'Lớp', value: 'class' },
        { text: 'Giáo viên', value: 'teachers' },
        // { text: 'Cơ sở', value: 'location' },
        { text: 'Mức học phí', value: 'price' },
        { text: 'Hình thức thu', value: 'paymentType' },
        { text: 'Định kỳ', value: 'periodic' },
        { text: 'Kỳ đóng thực tế', value: 'actualPaymentPeriod', align: 'center' },
        { text: 'Hành động', value: 'actions', align: 'center' },
      ],
    }
  },

  computed: {
    ...mapState('tuitionFeeClassSetup', ['items', 'total', 'loading']),
  },

  watch: {
    options: {
      handler() {
        this.fetchItems()
      },
      deep: true,
    },
  },

  created() {
    this.fetchItems()
  },

  methods: {
    formatPriceType(type) {
      const types = {
        per_session: '/ buổi',
        monthly: '/ tháng',
        quarterly: '/ 3 tháng',
        '2month': '/ 2 tháng',
        course: '/ khóa',
      }
      return types[type] || type
    },

    formatPaymentType(type) {
      const types = {
        pre: 'Thu trước (đầu kỳ)',
        post_actual: 'Thu sau (cuối kỳ)',
        post_expected: 'Thu sau (theo dự kiến)',
        pre_one: 'Thu trước (1 đợt)',
        pre_many: 'Thu trước (nhiều đợt)',
      }
      return types[type] || type
    },

    formatPeriodicType(type) {
      const types = {
        1: 'Theo mỗi tháng',
        2: '2 tháng 1 lần',
        3: '3 tháng 1 lần',
      }
      return types[type] || type
    },

    fetchItems() {
      const { page, itemsPerPage } = this.options

      const params = {
        _start: ((page || 1) - 1) * (itemsPerPage || 10),
        _limit: itemsPerPage || 10,
      }

      this.$store.dispatch('tuitionFeeClassSetup/fetchItems', params)
    },

    async editItem(item) {
      let isFinished = false
      if (get(item, 'metadata.apply')) {
        const feeGroupHeadFee = await this.$store.dispatch('tuitionFeeGroupHeadFee/fetchOne', item.metadata.apply)
        const prices = feeGroupHeadFee.prices
        isFinished  = prices.some(price => price.period.status === 'finished')
      }
      if (isFinished) {
        this.$dialog.confirm({
          title: 'Thông báo xác nhận',
          text: 'Cấu hình học phí đối với lớp học này đã được áp dụng tại các tháng trong quá khứ. Bạn không thể sửa ' +
            'lại bây giờ. Vui lòng thực hiện thao tác xóa và cấu hình lại nếu yêu cầu điều chỉnh là bắt buộc (sau đó, ' +
            'bạn có thể thực hiện tổng kết lại học phí riêng cho lớp học tại các kỳ đóng trong quá khứ).',
          type: 'confirm',
          okText: 'Xác nhận',
        })
      } else {
        this.$refs.dialogEditClassSetup.openDialog(item, get(item, 'class.metadata.classMode') === 'hybrid')
      }
    },

    deleteItem(item) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa',
        text: 'Bạn có chắc chắn muốn xóa cấu hình học phí này?',
        type: 'delete',
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.$store.dispatch('tuitionFeeClassSetup/remove', item.id)
            this.$toast.success('Xóa học phí thành công')
            this.fetchItems()
          } catch (error) {
            this.$toast.error('Xóa học phí thất bại')
          }
        },
      })
    },
  },
}
</script>
